export enum ROLES{
    CUSTOMER = "Customer",
    ADMIN = "Admin",
    SUB_ADMIN = "Sub-Admin",
    SUPER_ADMIN = "Super-Admin",
    CONTENT_WRITER = "Content-Writer"
}